import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  CoachingProfileView,
  CoachingStreakView,
} from '@euler/model/coaching-progress';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../ai-suite/theme';
import { CaseStarsList } from './components/CaseStarsList';
import { MilestoneList } from './components/MilestoneList';
import { ProfileRadar } from './components/ProfileRadar';
import { ProgressSection } from './components/ProgressSection';
import { StreakCard } from './components/StreakCard';

/**
 * 我的练习, above the attempts: the streak and goal, the profile radar,
 * stars per case and level, and milestones.
 */
export const ProgressHeader = memo(
  ({
    streak,
    profile,
    onEditGoal,
    onOpenLeaderboard,
  }: {
    streak: CoachingStreakView | null;
    profile: CoachingProfileView | null;
    onEditGoal: () => void;
    onOpenLeaderboard: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(12), paddingBottom: rpx(4) }}>
        {streak ? (
          <StreakCard
            streak={streak}
            onEditGoal={onEditGoal}
            onOpenLeaderboard={onOpenLeaderboard}
          />
        ) : null}
        {profile ? (
          <>
            <ProgressSection title="我的能力">
              <ProfileRadar areas={profile.areas} />
            </ProgressSection>
            {profile.cases.length ? (
              <ProgressSection title="各场景最好成绩">
                <CaseStarsList cases={profile.cases} />
              </ProgressSection>
            ) : null}
            <ProgressSection title="里程碑">
              <MilestoneList milestones={profile.milestones} />
            </ProgressSection>
          </>
        ) : null}
        <Typography.Text size={rpx(15)} bold color={aiColors.foreground}>
          练习记录
        </Typography.Text>
      </View>
    );
  },
);
